/*
 * Copyright (c) 2020. Minerva Networks.
 * All rights reserved.
 */

/* eslint no-param-reassign: ["error", { "props": false }] */

import Vue from 'vue';
import Vuex from 'vuex';
import find from 'lodash.find';
import replace from 'lodash.replace';
import isArray from 'lodash.isarray';
import set from 'lodash.set';
import has from 'lodash.has';
import max from 'lodash.max';
import assign from 'lodash.assign';
import assignIn from 'lodash.assignin';
import intersection from 'lodash.intersection';
import forIn from 'lodash.forin';
import remove from 'lodash.remove';
import forEach from 'lodash.foreach';
import omit from 'lodash.omit';
import get from 'lodash.get';
import template from 'lodash.template';
import isEmpty from 'lodash.isempty';
import isRetina from 'is-retina';
import { detect } from 'detect-browser';
import md5 from 'md5';
import axios from 'axios';
import Vc from './classes/PlayerState';
import colors from './assets/scss/current/_colors.scss';
// eslint-disable-next-line
import videojs from 'video.js';

/*
const getGaEvAction = (ev, state) => {
  let str = `${state.player.kind} ${ev}`;
  if (['Highlight', 'Play', 'Player'].includes(state.player.kind)) str += ` ${state.player.highlightId}`;
  return str;
};
const getGaEvLabel = state => state.player.video_id;
*/

Vue.use(Vuex);

function resizePlayer(state) {
  state.page.width = document.querySelector('#app').offsetWidth;
  state.page.height = window.innerHeight;
  state.page.ratio = state.page.width / state.page.height;
  // state.page.reverseRatio = state.page.height / state.page.width;
  state.page.orientation = state.page.ratio > 1 ? 'landscape' : 'portrait';
  const playerW = document.querySelector('.vjs-tech').offsetWidth;
  const playerH = document.querySelector('.vjs-tech').offsetHeight;
  const videoRatio = (playerH / playerW).toFixed(2);
  // let ratioPadding = '56.25%';
  let ratioPadding = `${(videoRatio * 100).toFixed(2)}%`;
  if (state.page.ratio > 1) {
    const pw = Math.round(state.page.height / videoRatio);
    const ph = Math.round(pw * videoRatio);
    state.page.playerWidth = `${pw}px`;
    state.page.playerHeight = `${ph}px`;
    // state.page.playerHeight = '0';
    ratioPadding = '0';
  } else {
    state.page.playerWidth = '100%';
    state.page.playerHeight = '0';
  }
  state.page.playerStyle = {
    width: state.page.playerWidth,
    height: state.page.playerHeight,
    paddingBottom: ratioPadding,
  };
}

const store = (conf, env, locale) => {
  const browser = detect();
  const compiledBaseUrl = template(conf[env].baseUrl);
  const baseUrl = compiledBaseUrl({ locale });

  return new Vuex.Store({
    state: {
      rdsPlayer: false,
      rdsPlayer360: false,
      rdsPlayerShow: false,
      rdsPlayer360Show: false,
      reactionStripeStatus: false,
      displayAvatar: false,
      reactionStripeConfig: false,
      altFaqRoute: false,
      showCamera: false,
      showPreview: false,
      ua: false,
      uaTa: false,
      showPopover: false,
      showReactionBar: false,
      canTakePicture: true,
      concertMap: {
        lacunacoil: conf[env].videoId,
      },
      displayRedeem: false,
      redeem: false,
      singleV: false,
      singleH: false,
      widgetMode: false,
      browser,
      logo: conf[env].logo,
      anim: {
        in: 'animated fadeInRight',
        out: 'animated fadeOutLeft',
      },
      modal: {
        display: false,
        title: false,
        text: false,
        cta: false,
        callback: false,
        animation: 'tada',
      },
      resizing: {
        t0: false,
        t1: false,
      },
      colors,
      blockGaEvents: false,
      locale,
      offersNeeded: [],
      appName: conf.appName,
      appVersion: conf.xTokVersion,
      isLoadingApi: false,
      helpLink: `mailto:support@alivemusic.tv?subject=Feedback for ${conf.appName} v. ${conf.xTokVersion} (${navigator.userAgent})`,
      navTitle: '',
      vc: false,
      videoDuration: -1,
      playedHMInit: -1,
      playedHM: null,
      playedms: 0,
      stopTime: false,
      previousTime: null,
      currentTime: 0,
      liveseekVector: [],
      livePreviousTime: -1,
      liveCurrentTime: 0,
      env,
      conf,
      login: {
        ...conf[env].login,
        returnUrl: `${baseUrl}login`,
      },
      baseUrl,
      ls: false,
      paymentReturnUrl: `${baseUrl}payment`,
      paymentCancelReturnUrl: `${baseUrl}paymentError`,
      referer: '/',
      me: false,
      displayMe: false,
      plans: false,
      availablePlans: false,
      loginInfo: false,
      home: false,
      page: {
        width: false,
        height: false,
        orientation: false,
        playerWidth: '100%',
        playerHeight: '0',
        playerStyle: {},
        index: 0,
      },
      api: axios.create({
        baseURL: conf[env].api.url,
        headers: {
          'x-tok-channel': conf.xTokChannel,
          'x-tok-key': conf.xTokKey,
          'x-tok-version': conf.xTokVersion,
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept-Language': locale,
        },
      }),
      papi: axios.create({
        baseURL: conf.special.api.url,
        headers: {
          'x-tok-channel': conf.xTokChannel,
          'x-tok-key': conf.xTokKey,
          'x-tok-version': conf.xTokVersion,
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept-Language': locale,
        },
      }),
      payWall: false,
      highlights: true,
      playerHighlights: false,
      plays: false,
      players: false,
      loading: true,
      seasonLoading: false,
      md: false,
      selectedCategory: false,
      selectedCategoryContent: false,
      availableImageSize: [
        '324',
        '576',
        '1080',
        '1920',
        '2304',
        '3072',
        '4096',
      ],
      imageQueue: [],
      imagesLoaded: [],
      highlights_on: false,
      playerHighlights_on: false,
      plays_on: false,
      players_on: false,
      related_on: false,
      smartHighlights: false,
      playerDisplay: false,
      player: {
        muted: true,
        playerMenu: true,
        video_id: null,
        highlightId: false,
        video_type: null,
        kind: null,
        title: null,
        description: null,
        cover: null,
        stream_hls: null,
        live_badge_shown: null,
        related_videos: false,
      },
      playerState: {
        playing: false,
        paused: false,
      },
      playerInstance: null,
      livePlayerState: {
        playing: true,
        paused: false,
      },
      livePlayerInstance: false,
      livePlayerDisplay: false,
      hls: false,
      liveHls: false,
      playerSize: {},
      playerInit: false,
      livePlayerOptions: {
        width: '640',
        fluid: true,
        muted: true,
        autoplay: true,
        playsinline: true,
        controls: false,
        language: 'en',
        playbackRates: false,
        sources: [{
          withCredentials: false,
          type: 'application/x-mpegURL',
          src: conf.initStream,
        }],
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          fullscreenDisplay: false,
        },
        // flash: { hls: { withCredentials: false } },
        // html5: { hls: { withCredentials: false } },
        poster: '',
      },
      playerOptions: {
        width: '640',
        fluid: true,
        muted: false,
        autoplay: false,
        playsinline: true,
        language: 'en',
        playbackRates: false,
        sources: [{
          withCredentials: false,
          type: 'application/x-mpegURL',
          src: conf.initStream,
        }],
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          fullscreenToggle: false,
        },
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
        poster: '',
      },
    },
    getters: {
      faqRoute(state) {
        return state.altFaqRoute ? state.altFaqRoute : '/faq';
      },
      metamask() {
        if (get(window, 'web3.currentProvider.isMetaMask', false)) {
          return true;
        }
        return false;
      },
      getPI(state) {
        if (state.playerInstance) {
          window.app.$log.debug('Returning current player instance');
          return state.playerInstance;
        }
        window.app.$log.debug('No current player instance, retriving it by querySelector');
        const vel = document.querySelector('.videoInstance video');
        return vel ? videojs(vel.getAttribute('id')) : null;
      },
      getLPI(state) {
        if (state.livePlayerInstance) {
          return state.livePlayerInstance;
        }
        const vel = document.querySelector('.liveInstance video');
        return state.home.embedded_video && vel ? videojs(vel.getAttribute('id')) : null;
      },
      getToken(state) {
        return state.loginInfo.token;
      },
      getImageSize(state) {
        return (ts) => {
          const m = find(state.availableImageSize, s => s > ts);
          if (!m) {
            return max(state.availableImageSize);
          }
          return m;
        };
      },
      scaleImage(state, getters) {
        return (url, ratio = 1) => {
          let as = state.page.width > 1200 ? 1200 : state.page.width;
          if (isRetina()) {
            as *= 2;
          }
          let mpl = ratio;
          if (isArray(ratio)) {
            mpl = ratio[state.page.index];
          }
          const ts = as * mpl;
          const val = replace(url, '{$width}', getters.getImageSize(ts));
          return val;
        };
      },
      getNavTitle(state) {
        return state.navTitle;
      },
      isWidget(state) {
        return state.widgetMode || window.app.$ls.get('widgetMode');
      },
    },
    mutations: {
      setRdsPlayer(state, payload) {
        state.rdsPlayer = payload;
      },
      setRdsPlayer360(state, payload) {
        state.rdsPlayer360 = payload;
      },
      setRdsPlayerShow(state, payload) {
        state.rdsPlayerShow = payload;
      },
      setRdsPlayer360Show(state, payload) {
        state.rdsPlayer360Show = payload;
      },
      setReactionStripeConfig(state, payload) {
        state.reactionStripeConfig = payload;
      },
      setAvatar(state, payload) {
        state.me.avatar = `data:image/jpg;base64,${payload}`;
      },
      displayAvatar(state, payload) {
        state.displayAvatar = payload;
      },
      setUa(state, payload) {
        clearTimeout(state.uaTa);
        state.ua = payload;
        state.uaTa = setTimeout(() => {
          state.ua = false;
          state.showPopover = false;
        }, 2500);
      },
      showReactionBar(state, payload) {
        state.showReactionBar = payload;
      },
      setCanTakePicture(state, payload) {
        state.canTakePicture = payload;
      },
      showCamera(state, payload) {
        state.showCamera = payload;
      },
      showPreview(state, payload) {
        state.showPreview = payload;
      },
      setWidgetMode(state, payload) {
        state.widgetMode = payload;
        window.app.$ls.set('widgetMode', payload);
        window.app.$ls.set('referrer', payload ? '/widget' : '/', 20000);
        state.referer = payload ? '/widget' : '/';
      },
      reverseAnimation(state) {
        state.anim.in = 'animated fadeInLeft';
        state.anim.out = 'animated fadeOutRight';
      },
      resetAnimation(state) {
        state.anim.in = 'animated fadeInRight';
        state.anim.out = 'animated fadeOutLeft';
      },
      initModal(state, payload) {
        assignIn(state.modal, payload);
      },
      resetTracking(state) {
        if (state.vc) {
          state.vc.performance.playbackMap = state.vc.completion;
          state.vc.performance.videoId = state.player.video_id;
          state.vc.performance.videoTitle = state.player.title;
          state.vc.performance.video_type = state.player.video_type;
          let bt = 0;
          forEach(state.vc.performance.interruptions, (i) => {
            const t = i.resumeTime - i.startTime;
            bt += t;
          });
          window.app.$log.info(`Video Buffering Time ${bt}`);
          window.app.$log.info(`Video Buffering Interruptions ${state.vc.performance.interruptions.length}`);
          window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, 'Video Buffering Time', state.player.video_id, bt);
          window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, 'Video Buffering Interruptions', state.player.video_id, state.vc.performance.interruptions.length);
        }
        state.vc = false;
        state.videoDuration = -1;
        state.playedHMInit = -1;
        state.playedms = 0;
        state.previousTime = 0;
      },
      setNavTitle(state, title) {
        state.navTitle = title;
      },
      displayPaywall(state, payload) {
        state.payWall = payload;
      },
      canSee(state, payload) {
        const canSee = intersection(payload.offers, state.availablePlans.active_plans);
        return canSee;
      },
      redirectToIP(state, payload) {
        // if ('ls' in payload) payload.ls.set('loggingIn', true, 60 * 5 * 1000);
        const args = assignIn(state.login, payload);
        if (args.registered) {
          window.ga('tok.send', 'event', 'Registration', 'Registration Proposed');
        }
        if (has(payload, 'route')) {
          payload.ls.set('referrer', payload.route);
        }
        const returnURI = payload.returnURI ? payload.returnURI : state.login.returnUrl;
        const opt = payload.event ? `&event=${payload.event}` : '';
        const url = `${state.login.ip}login?app=${state.login.app}&service=${state.login.service}&registered=${args.registered}&url=${encodeURIComponent(returnURI)}${opt}`;
        window.location = url;
      },
      setReferer(state, payload) {
        state.referer = payload;
      },
      setMe(state, payload) {
        const info = { ...payload };
        if (!has(info, 'avatar')) {
          set(info, 'avatar', false);
        }
        state.me = info;
        if (window.app.$ls.get('singleH') || window.app.$ls.get('singleV')) {
          state.me.onboarding = false;
        }
      },
      displayMe(state, payload) {
        state.displayMe = payload;
      },
      setLoginInfo(state, payload) {
        state.loginInfo = payload;
      },
      toggleMute(state) {
        state.player.muted = !state.player.muted;
      },
      playerReadied(state, player) {
        window.app.$log.info('Player readied');
        /* reset tracking start */
        state.vc = false;
        state.videoDuration = -1;
        state.playedHMInit = -1;
        state.playedms = 0;
        state.previousTime = 0;
        /* reset tracking end */
        state.playerInstance = player;
        player.controlBar.addChild('button', {
          text: 'FullScreen',
          tabIndex: 3,
        })
          .addClass('vjs-fullscreen-control');
        document.querySelector('.vjs-fullscreen-control')
          .addEventListener('click', () => {
            window.app.$fullscreen.toggle(document.querySelector('.videoContainer'), {
              wrap: false,
              callback: () => {
                this.fullscreen = !this.fullscreen;
              },
            });
          });

        state.hls = player.tech({ IWillNotUseThisInPlugins: true }).hls;

        // window.yb_plugin = new youbora.Plugin({ accountCode: 'minervadev' });
        /*
        window.yb_plugin.setOptions({
          'content.isLive': false,
          'content.title': 'Title of the content'
        });
        */
        // window.yb_plugin.setAdapter(new youbora.adapters.Videojs(player));
      },
      playerStateChanged() {

      },
      onTimeUpdate(state, event) {
        if (event.currentTime() < 1) {
          return;
        }
        if (!state.vc && event.duration() > 0 && event.duration() !== Infinity) {
          const d = event.duration();
          state.vc = new Vc(d);
          window.app.$log.info(`Video duration is: ${event.duration()}`);
          event.on('seeking', () => {
            if (state.vc) {
              if (!state.vc.seeking) {
                state.vc.seeking = true;
                window.app.$log.info('Start Seeking');
              }
            }
          });
          event.on('waiting', () => {
            const isInitVideo = state.playerInstance.src() === conf.initStream;
            if (!isInitVideo) {
              if (has(state, 'vc.stalled')) {
                set(state, 'vc.stalled', event.currentTime());
              }
              if (has(state, 'vc.stalledTime')) {
                set(state, 'vc.stalledTime', new Date().getTime());
              }
              window.app.$log.info('Video is in waiting state');
            }
          });
          event.on('playing', () => {
            const isInitVideo = state.playerInstance.src() === conf.initStream;
            if (!isInitVideo && state.vc.stalled !== false && state.vc.stalled >= 0) {
              const now = new Date().getTime();
              state.vc.performance.interruptions.push({
                at: state.vc.stalled,
                startTime: state.vc.stalledTime,
                resumeTime: now,
              });
              state.vc.stalled = false;
              window.app.$log.info('Resuming video from stalled state');
            }
          });
        }
        if (state.vc) {
          const ct = event.currentTime();
          const diff = state.vc.getDiff(ct);
          if (diff > 0 && diff < 1000) {
            if (state.vc.seeking) {
              // const seekDiff = state.vc.getSeekDiff(ct);
              // if (seekDiff > 0) {
              //   window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, getGaEvAction('Seek Forward', state), getGaEvLabel(state), (Math.abs(seekDiff) / 1000));
              // } else {
              //   window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, getGaEvAction('Seek Backward', state), getGaEvLabel(state), (Math.abs(seekDiff) / 1000));
              // }
              state.vc.seeking = false;
            } else {
              state.vc.setPreviousTime(ct);
            }
            state.vc.setPlayed(ct);

            const isInitVideo = state.playerInstance.src() === conf.initStream;

            const viewed = state.vc.getViewed();
            if (viewed > 25 && !state.vc.e25 && state.player.video_type && !isInitVideo) {
              // window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, getGaEvAction('First Quartile', state), getGaEvLabel(state));
              state.vc.e25 = true;
            }
            if (viewed > 50 && !state.vc.e50 && state.player.video_type && !isInitVideo) {
              // window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, getGaEvAction('Mid Point', state), getGaEvLabel(state));
              state.vc.e50 = true;
            }
            if (viewed > 75 && !state.vc.e75 && state.player.video_type && !isInitVideo) {
              // window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, getGaEvAction('Third Quartile', state), getGaEvLabel(state));
              state.vc.e75 = true;
            }
          }
          state.vc.setPreviousTimeUpdate(ct);
        }
      },
      onPlayerEnded(state) {
        // const isInitVideo = state.playerInstance.src() === conf.initStream;
        // if (!isInitVideo) window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, getGaEvAction('Completed', state), getGaEvLabel(state));
        if (state.player.related_videos) {
          state.related_on = true;
        }
      },
      onPlayerPause(state) {
        // const isInitVideo = state.playerInstance.src() === conf.initStream;
        state.playerState.paused = true;
        state.playerState.playing = false;
        /*
        setTimeout(() => {
          if (!state.vc.seeking && state.player.video_id && !state.blockGaEvents && !isInitVideo) {
            window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, getGaEvAction('Stopped', state), getGaEvLabel(state));
          }
        }, 300);
        */
      },
      onPlayerPlay(state) {
        // const isInitVideo = state.playerInstance.src() === conf.initStream;
        state.playerState.paused = false;
        state.playerState.playing = true;
        setTimeout(() => {
          /*
          if (!state.vc.seeking && state.player.video_id && !state.blockGaEvents && !isInitVideo) {
            window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, getGaEvAction('Started', state), getGaEvLabel(state));
          }
          */
          resizePlayer(state);
        }, 300);
      },
      onLiveTimeUpdate(state, event) {
        state.livePreviousTime = state.liveCurrentTime;
        state.liveCurrentTime = event.currentTime();
      },
      onLivePlayerPause(state) {
        // setTimeout(() => {
        //   if (!state.vc.seeking && !state.blockGaEvents) {
        //     window.ga('tok.send', 'event', 'Main Embedded Video', 'Video Stopped', state.home.embedded_video.video_id);
        //   }
        // }, 300);
        state.livePlayerState.paused = true;
        state.livePlayerState.playing = false;
      },
      onLivePlayerPlay(state) {
        // setTimeout(() => {
        //   if (!state.vc.seeking && !state.blockGaEvents) {
        //     window.ga('tok.send', 'event', 'Main Embedded Video', 'Video Started', state.home.embedded_video.video_id);
        //   }
        // }, 300);
        state.livePlayerState.paused = false;
        state.livePlayerState.playing = true;
      },
      onLivePlayerEnded(state) {
        window.app.$log.info(`Main Embedded Video Completed ${state.home.embedded_video.video_id}`);
        // window.ga('tok.send', 'event', 'Main Embedded Video', 'Video Completed', state.home.embedded_video.video_id);
      },
      livePlayerStateChanged(state, status) {
        window.app.$(status);
      },
      exitVideo(state) {
        document.querySelector('body').style.overflow = 'auto';
        state.playerHighlights_on = false;
        state.playerDisplay = false;
        if (state.playerInstance) {
          state.playerInstance.src({
            withCredentials: false,
            type: 'application/x-mpegURL',
            src: conf.initStream,
          });
        }
        state.livePlayerDisplay = true;
        if (state.livePlayerInstance) {
          state.livePlayerInstance.play()
            .catch(() => {
              window.app.$log.debug('livePlayerInstance not visible');
            });
        }
        state.related_on = false;
        // document.querySelector('body').classList.remove('noScroll');
      },
      loadVideo(state, url) {
        state.playerInstance.src({
          withCredentials: false,
          type: 'application/x-mpegURL',
          src: url,
        });
        state.showReactionBar = true;
      },
      // https://vp-demo.tok.tv/minerva/#/highlight/d4a5c6e6-5f65-470e-ac51-a451d288f074
      loadDashVideo(state, url) {
        state.playerInstance.src({
          withCredentials: false,
          type: 'application/dash+xml',
          src: url,
        });
        state.showReactionBar = true;
      },
      setMd(state, payload) {
        state.md = payload;
      },
      appReady(state, payload) {
        state.loading = !payload;
      },
      setReactionStripeStatus(state, payload) {
        state.reactionStripeStatus = payload;
      },
      seasonReady(state, payload) {
        state.seasonLoading = !payload;
      },
      setHomeData(state, payload) {
        state.home = payload;

        if (payload.embedded_video) {
          state.player.title = payload.embedded_video.title;
          state.player.description = payload.embedded_video.description;
        }
      },
      setHighlights(state, payload) {
        state.highlights = payload;
        state.playerHighlights = false;
        state.plays = false;
        state.players = false;
      },
      displayHighlights(state, payload) {
        state.highlights_on = payload;
        state.playerHighlights_on = false;
        state.plays_on = false;
        state.players_on = false;
      },
      setPlayerHighlights(state, payload) {
        state.highlights = false;
        state.playerHighlights = payload;
        state.plays = false;
        state.players = false;
      },
      displayPlayerHighlights(state, payload) {
        state.highlights_on = false;
        state.playerHighlights_on = payload;
        state.plays_on = false;
        state.players_on = false;
      },
      setPlays(state, payload) {
        state.plays = payload;
        state.players = false;
        state.highlights = false;
        state.playerHighlights = false;
      },
      displayPlays(state, payload) {
        state.plays_on = payload;
        state.players_on = false;
        state.highlights_on = false;
        state.playerHighlights_on = false;
      },
      setPlayers(state, payload) {
        state.players = payload;
        state.highlights = false;
        state.playerHighlights = false;
        state.plays = false;
      },
      displayPlayers(state, payload) {
        state.players_on = payload;
        state.plays_on = false;
        state.highlights_on = false;
        state.playerHighlights_on = false;
      },
      displayRelated(state, payload) {
        state.related_on = payload;
      },
      setPlayer(state, payload) {
        state.player = payload;
      },
      loadCategory(state, payload) {
        state.selectedCategory = payload;
      },
      loadCategoryContent(state, payload) {
        state.selectedCategoryContent = payload;
      },
      assignCategoryContent(state, payload) {
        assign(state.selectedCategoryContent, payload);
      },
      refreshPageSizeInfo(state) {
        resizePlayer(state);
        switch (true) {
          case (state.page.width <= 576):
            state.page.index = 0;
            break;
          case (state.page.width <= 768):
            state.page.index = 1;
            break;
          case (state.page.width <= 992):
            state.page.index = 2;
            break;
          case (state.page.width <= 1200):
            state.page.index = 3;
            break;
          default:
            state.page.index = 4;
        }
      },
      setLivePlayerInstance(state, payload) {
        state.livePlayerInstance = payload;
      },
      displayLivePlayer(state, payload) {
        state.livePlayerDisplay = payload;
      },
      loadPaywall() {
        window.app.$router.push('/paywall');
      },
      closeRedeem(state) {
        state.displayRedeem = false;
      },
      loadRedeem(state, payload) {
        state.redeem = payload;
        // state.displayRedeem = true;
        const route = get(payload, 'route', '/paywall');
        window.app.$router.push(route);
      },
      closePaywall(state) {
        state.payWall = false;
      },
      setPlayerInfo(state, payload) {
        state.player.video_id = payload.video_id;
        state.player.video_type = payload.video_type;
        state.player.title = payload.title;
        state.player.description = payload.description;
        state.player.cover = payload.cover;
        state.player.stream_hls = payload.stream_hls;
        state.player.live_badge_shown = payload.live_badge_shown;
        state.player.related_videos = payload.related_videos;
        state.playerDisplay = true;
      },

    },
    actions: {
      setShowPopover({ state, commit }, payload) {
        const img = new Image();
        img.onload = () => {
          state.showPopover = payload;
          commit('setUa', true);
        };
        img.src = payload;
      },
      getMe({ state, commit }) {
        return new Promise((resolve, reject) => {
          state.api.get('/me', {
            headers: {
              'x-tok-token': state.loginInfo.token,
              'Accept-Language': state.locale,
            },
          })
            .then((response) => {
              commit('setMe', response.data);
              if (state.me.registered) {
                window.ga('tok.set', 'dimension6', 1);
                if (state.me.active_offers) {
                  window.ga('tok.set', 'dimension7', state.me.active_offers.join(','));
                }
              } else {
                window.ga('tok.set', 'dimension6', 0);
              }
              resolve(response.data);
            })
            .catch((e) => {
              reject(e);
            });
        });
      },
      getPlans({ state }, payload) {
        if (state.me.registered) {
          return new Promise((resolve) => {
            if (!payload) {
              const cachedAvailablePlans = window.app.$ls.get('availablePlans');
              if (cachedAvailablePlans) {
                state.plans = cachedAvailablePlans;
                state.availablePlans = cachedAvailablePlans;
                return;
              }
            }
            // state.api.get('/offer-plans?types=paypal,cbether', {
            state.api.get('/offer-plans?types=ticket', {
              headers: {
                'x-tok-token': state.loginInfo.token,
                'Accept-Language': state.locale,
              },
            })
              .then((response) => {
                state.plans = response.data;
                state.availablePlans = response.data;
                window.app.$ls.set('availablePlans', response.data, 60 * 2 * 1000);
                resolve();
              })
              .catch(() => {
                window.app.$log.error('Unable to retrive Plans data');
              });
          });
        }
        return new Promise((resolve) => {
          state.plans = false;
          state.availablePlans = false;
          resolve();
        });
      },
      loadVideo({ commit }, payload) {
        return new Promise((resolve) => {
          commit('loadVideo', payload);
          resolve(true);
        });
      },
      loadNegramaro({ state }) {
        return new Promise((resolve, reject) => {
          state.api.get('/negramaro/videos', {
            headers: {
              'x-tok-token': state.loginInfo.token,
              'Accept-Language': state.locale,
            },
          })
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
      loadWidget({ state }) {
        return new Promise((resolve, reject) => {
          state.api.get('/widget', {
            headers: {
              'x-tok-token': state.loginInfo.token,
              'Accept-Language': state.locale,
            },
          })
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
      setLoginInfo({ commit }, payload) {
        return new Promise((resolve) => {
          commit('setLoginInfo', payload);
          resolve();
        });
      },
      logout({ state }) {
        return new Promise((resolve) => {
          state.loginInfo = false;
          state.me = false;
          resolve();
        });
      },
      getHome({ state, commit }, ls) {
        return new Promise((resolve, reject) => {
          state.api.get('/home', {
            headers: {
              'x-tok-token': state.loginInfo.token,
              'Accept-Language': state.locale,
            },
          })
            .then((response) => {
              ls.set('storageHomeData', response.data, 1 * 60 * 1000);
              commit('setHomeData', response.data);
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
      // eslint-disable-next-line
      playVideoById({
        dispatch,
        commit,
        state,
        getters,
      }, payload) {
        state.isLoadingApi = true;
        if (payload.ga === 'Onboarding') {
          window.app.$log.debug('Track GA Onboarding');
          state.me.onboarding = false;
          const token = get(state, 'loginInfo.token');
          if (!token) {
            window.app.$log.debug('No token redirecting to home');
            window.app.$router.push('/');
          }
          state.api.put('/onboarding', null, {
            headers: {
              'x-tok-token': token,
            },
          })
            .then(() => {
              dispatch('getMe')
                .then(() => {
                  window.app.$log.debug('Onboarding completed');
                });
            })
            .catch(() => {
              window.app.$log.debug('Error while setting completed onboarding');
            });
        } else {
          commit('resetTracking');
          window.app.$log.debug('Track GA Launch Video');
          window.ga('tok.send', 'event', payload.ga, 'Launch Video', payload.id);
        }
        window.app.$log.debug('Checking offers...');
        if (payload.offers) {
          window.app.$log.debug('The video has offers');
          const myOffers = get(state, 'me.active_offers', []);
          const canSee = intersection(payload.offers, myOffers);
          if (!canSee.length) {
            window.app.$log.debug('User don\'t have the right to see this video');
            if (!state.me.registered) {
              window.app.$log.debug('User not registered redirect to IP');
              window.app.$ls.set('nextAction', 'playVideoById', 60 * 2 * 1000);
              window.app.$ls.set('nextPayload', omit(payload, ['router']), 60 * 2 * 1000);
              return commit('redirectToIP', {
                router: payload.router,
                registered: true,
              });
              // eslint-disable-next-line
            } else {
              window.app.$log.debug('User registered');
              state.offersNeeded = payload.offers;
              window.app.$ls.remove('nextAction');
              window.app.$ls.remove('nextPayload');
              commit('loadRedeem', {
                ...payload,
                play: true,
              });
              // commit('loadPaywall');
              // eslint-disable-next-line
              return;
            }
            // eslint-disable-next-line
          } else {
            const na = window.app.$ls.get('nextAction');
            const np = window.app.$ls.get('nextPayload');
            if (na && np) {
              window.app.$ls.remove('nextAction');
              window.app.$ls.remove('nextPayload');
              // eslint-disable-next-line
              return;
            }
          }
        }
        commit('displayRelated', false);
        try {
          window.app.$log.debug('If live player pause it');
          if (getters.getLPI) getters.getLPI.pause();
        } catch (e) {
          window.app.$log.debug('Problem while pausing live player');
          window.app.$log.info('No Live Player');
        }
        window.app.$log.debug('Initialise player');
        state.blockGaEvents = true;
        const playPromise = getters.getPI.play();
        window.app.$log.debug(browser.name);
        if (!payload.id) {
          payload.id = payload.video_id;
        }
        if (browser.name === 'edge') {
          window.app.$log.debug('No promise play');
          dispatch('handleVideo', payload);
        } else {
          window.app.$log.debug('Promise play');
          playPromise
            .then(() => {
              dispatch('handleVideo', payload);
            })
            .catch((e) => {
              window.app.$log.debug(`Error while Initialising the player ${e}`);
            });
        }
      },
      handleVideo({
        dispatch,
        commit,
        state,
        getters,
      }, payload) {
        window.app.$log.debug('Init Play Successfull');
        try {
          getters.getPI.pause();
          window.app.$log.debug('Init Pause Successfull');
          state.blockGaEvents = false;
          const token = get(state, 'loginInfo.token');
          if (!token) {
            window.app.$log.debug('No token redirect to home');
            window.app.$router.push('/');
            // window.location.reload();
          }
          window.app.$log.debug('Loading video data...');
          state.api.get(`/video/${payload.id}`, {
            headers: {
              'x-tok-token': token,
              'Accept-Language': state.locale,
            },
          })
            .then((response) => {
              window.app.$log.debug('Video data loaded');
              state.player.video_id = response.data.video_id;
              state.player.video_type = response.data.video_type;
              state.player.kind = 'Video';
              state.player.title = response.data.title;
              state.player.description = response.data.description;
              state.player.cover = response.data.cover;
              state.player.stream_hls = response.data.stream_hls;
              state.player.live_badge_shown = response.data.live_badge_shown;
              state.player.related_videos = response.data.related_videos;
              state.playerDisplay = true;
              // document.querySelector('body').classList.add('noScroll');
              state.isLoadingApi = false;
              commit('displayLivePlayer', false);
              commit('showReactionBar', true);
              state.livePlayerState = {
                playing: false,
                paused: true,
              };
              if (window.ga) window.ga('send', 'screenview', { screenName: `Video ${state.player.video_id}` });
              let dv = [];
              switch (state.player.video_type) {
                case 'live':
                  window.app.$log.debug('It\'s live video');
                  commit('loadVideo', response.data.stream_hls);
                  state.highlights_on = false;
                  getters.getPI.controls(false);
                  getters.getPI.userActive(true);
                  getters.getPI.poster(getters.scaleImage(response.data.cover));
                  document.querySelector('body').style.overflow = 'hidden';
                  getters.getPI.play();
                  /*
                    .then(() => {
                      // window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, `${state.player.kind} Started`, state.player.video_id);
                    })
                    .catch((e) => {
                      window.app.$log.error(`Unable to play video: ${e}`);
                    });
                    */
                  break;
                case 'smart-highlights':
                  window.app.$log.debug('It\'s smart highlights');
                  state.player.kind = 'Highlight';
                  state.highlights_on = true;
                  state.playerHighlights_on = false;
                  state.plays_on = false;
                  state.players_on = false;
                  getters.getPI.controls(true);
                  // getters.getPI.reset();
                  dv = find(response.data.smart_highlights.highlights, v => v.default);
                  if (dv) commit('loadVideo', dv.stream_hls);
                  getters.getPI.poster(getters.scaleImage(state.player.cover));
                  state.smartHighlights = response.data.smart_highlights.highlights;
                  state.plays = response.data.smart_highlights.plays;
                  state.players = response.data.smart_highlights.players;
                  document.querySelector('body').style.overflow = 'hidden';
                  window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, 'Highlight Started', state.player.video_id);
                  break;
                case 'player-highlights':
                  window.app.$log.debug('It\'s aplayer highlights');
                  state.player.kind = 'Player Highlight';
                  state.playerHighlights_on = true;
                  state.highlights_on = false;
                  state.plays_on = false;
                  state.players_on = false;
                  getters.getPI.controls(true);
                  state.playerHighlights = response.data;
                  document.querySelector('body').style.overflow = 'hidden';
                  if (dv) commit('loadVideo', conf.initStream);
                  getters.getPI.poster(getters.scaleImage(response.data.cover));
                  break;
                default:
                  window.app.$log.debug('Default video case');
                  dispatch('loadVideo', response.data.stream_hls)
                    .then(() => {
                      getters.getPI.poster(getters.scaleImage(response.data.cover));
                      state.highlights_on = false;
                      getters.getPI.controls(true);
                      getters.getPI.userActive(true);
                      getters.getPI.play();
                      document.querySelector('body').style.overflow = 'hidden';
                      window.ga('tok.send', 'event', `Video ${state.player.video_type.toUpperCase()}`, 'Video Started', state.player.video_id);
                    })
                    .catch((e) => {
                      window.app.$log.error(e);
                    });
              }

              state.related_on = false;
            })
            .catch((e) => {
              window.app.$log.debug('Error while loading video data');
              if (get(e, 'response.status', false) === 403) {
                window.app.$log.info('Login required');
              } else {
                window.app.$log.error('Unable to load video info');
              }
              state.isLoadingApi = false;
            });
        } catch (e) {
          window.app.$log.info('Unable to pause video');
        }
      },
      loadTheVideo({
        getters,
        commit,
        state,
        dispatch,
      }, payload) {
        dispatch('getMe').then(() => {
          if (!state.me.registered) {
            commit('redirectToIP', {
              router: payload.router,
              registered: true,
            });
            return;
          }
          const { offers } = payload;
          if (offers) {
            const myOffers = get(state, 'me.active_offers', []);
            const canSee = intersection(offers, myOffers);
            if (!canSee.length) {
              commit('loadRedeem', {
                ...payload,
                play: false,
                load: true,
              });
              return;
            }
          }
          const token = get(state, 'loginInfo.token');
          state.api.get(`/video/${state.singleV}`, {
            headers: {
              'x-tok-token': token,
              'Accept-Language': state.locale,
            },
          })
            .then((response) => {
              window.app.$ls.remove('singleV');
              switch (response.data.video_type) {
                case 'vod':
                case 'live':
                  getters.getPI.controls(false);
                  getters.getPI.poster(getters.scaleImage(response.data.cover));
                  document.querySelector('body').style.overflow = 'hidden';
                  state.player.video_type = response.data.video_type;
                  state.playerDisplay = true;
                  commit('loadVideo', response.data.stream_hls);
                  commit('appReady', true);
                  setTimeout(() => {
                    commit('refreshPageSizeInfo');
                  }, 500);
                  break;
                default:
                  break;
              }
            });
        }).catch((e) => {
          window.app.$log.error(`Error while loading me ${e}`);
        });
      },
      loadTheHighlight({ getters, commit, state }) {
        const token = get(state, 'loginInfo.token');
        state.api.get(`/video/${state.singleH}`, {
          headers: {
            'x-tok-token': token,
            'Accept-Language': state.locale,
          },
        })
          .then((response) => {
            const type = response.data.video_type.replace('-', '_');
            window.app.$ls.remove('singleH');
            switch (response.data.video_type) {
              case 'player-highlights':
                state.player.kind = 'Player Highlight';
                state.playerHighlights_on = true;
                state.highlights_on = false;
                state.plays_on = false;
                state.players_on = false;
                break;

              default:
                state.player.kind = 'Highlight';
                state.playerHighlights_on = false;
                state.highlights_on = true;
                state.plays_on = false;
                state.players_on = false;
                break;
            }
            getters.getPI.controls(true);
            let dv = [];
            switch (response.data.video_type) {
              case 'player-highlights':
                getters.getPI.poster(getters.scaleImage(response.data.cover));
                state.playerHighlights = response.data;
                document.querySelector('body').style.overflow = 'hidden';
                if (dv) commit('loadVideo', conf.initStream);
                break;
              default:
                getters.getPI.poster(getters.scaleImage(response.data.cover));
                state.smartHighlights = response.data[type].highlights;
                state.plays = response.data[type].plays;
                state.players = response.data[type].players;
                dv = find(response.data[type].highlights, v => v.default);
                document.querySelector('body').style.overflow = 'hidden';
                if (dv) commit('loadVideo', dv.stream_hls);
                break;
            }
            state.player.video_type = response.data.video_type;
            state.playerDisplay = true;
            commit('appReady', true);
          });
      },
      setHomeData(context, payload) {
        return new Promise((resolve) => {
          context.commit('setHomeData', payload);
          resolve();
        });
      },
      appReady(context, payload) {
        return new Promise((resolve) => {
          context.commit('appReady', payload);
          resolve(true);
        });
      },
      seasonReady(context, payload) {
        return new Promise((resolve) => {
          context.commit('seasonReady', payload);
          resolve();
        });
      },
      assignCategoryContent(context, payload) {
        return new Promise((resolve) => {
          context.commit('assignCategoryContent', payload);
          resolve();
        });
      },
      loadCategoryContent(context, payload) {
        return new Promise((resolve) => {
          context.commit('loadCategoryContent', payload);
          resolve();
        });
      },
      loadCategory(context, payload) {
        return new Promise((resolve) => {
          context.commit('loadCategory', payload);
          resolve();
        });
      },
      enqueueNestedCovers({ state, getters }, stuff) {
        return new Promise((resolve) => {
          // const loaderVar = stuff.loader || 'loading';
          // state[loaderVar] = true;
          forIn(stuff.data, (category) => {
            forIn(category.videos, (video) => {
              if (!isEmpty(video.cover)) {
                const coverWithSize = getters.scaleImage(video.cover, stuff.ratios);
                state.imageQueue.push(coverWithSize);
              }
            });
          });
          resolve();
        });
      },
      enqueueCovers({ state, getters }, stuff) {
        return new Promise((resolve) => {
          // const loaderVar = stuff.loader || 'loading';
          // state[loaderVar] = true;
          forIn(stuff.data.videos, (video) => {
            if (!isEmpty(video.cover)) {
              const coverWithSize = getters.scaleImage(video.cover, stuff.ratios);
              state.imageQueue.push(coverWithSize);
            }
          });
          resolve();
        });
      },
      enqueueImage({ state, getters }, stuff) {
        return new Promise((resolve) => {
          // const loaderVar = stuff.loader || 'loading';
          // state[loaderVar] = true;
          if (!isEmpty(stuff.url)) {
            const imgUrl = getters.scaleImage(stuff.url);
            state.imageQueue.push(imgUrl);
          }
          resolve();
        });
      },
      processEnqueuedImages({ dispatch, state }, loader) {
        return new Promise((resolve) => {
          state.loading = false;
          const loaderVar = loader || 'loading';
          state[loaderVar] = false;
          forIn(state.imageQueue, (i) => {
            const hash = `.h${md5(i)}`;
            const img = new Image();
            img.onload = () => {
              dispatch('removeFromQueue', i)
                .then(() => {
                  forEach(document.getElementsByClassName(hash), (e) => {
                    e.style.backgroundImage = `url(${i})`;
                    e.classList.add('show');
                  });
                  if (state.imageQueue.length === 0) {
                    resolve();
                  }
                })
                .catch((e) => {
                  window.app.$log.error(`Error while loading image ${e}`);
                });
            };
            img.src = i;
          });
        });
      },
      removeFromQueue({ state }, i) {
        return new Promise((resolve) => {
          remove(state.imageQueue, x => x === i);
          resolve();
        });
      },
    },
  });
};
export default store;
